var Component = require("../../model/Component");

Component.registerSubTypeDefaulter('dataZoom', function () {
  // Default 'slider' when no type specified.
  return 'slider';
});


//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/dataZoom/typeDefaulter.js
// module id = 346
// module chunks = 0